/****************************************************
 * Module Name:  mixSellInvoice.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Box, Button, CircularProgress, Tooltip, Typography, Stack, styled, FormGroup, FormControlLabel, Switch } from "@mui/material";
import Constants from "../../utility/constants";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Utility from "../../utility/utility";
import { DataGridPro, GridToolbar, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { BsFilePdf } from "react-icons/bs";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { LoadingButton } from "@mui/lab";
import CommonSnackbar from "../common/commonSnackBar";
import MixSaleProxy from "../../utility/proxy/manager/mixProxy/mixSalesProxy";
import PDFModal from "../common/pdfModal";
import dayjs from "dayjs";
import BucketDetailModal from "../mixDiamondSales/bucketDetailModal";
import renderCellExpand from "../common/dataGridCellExpand";
import PageTitle from "../common/pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
  Mylayout: {
    fillColor: function (rowIndex, node, columnIndex) {
      return rowIndex % 2 === 0 ? "#CCCCCC" : null;
    },
  },
};

const lStatusOption = [
  { value: "UNPAID", label: "UNPAID" },
  { value: -1, label: "-- ANY --" },
  { value: "PAID", label: "PAID" },
  { value: "CANCELLED", label: "CANCELLED" },
];

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
  '& .super-app-theme--Paid': {
    color: 'green',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  '& .super-app-theme--PartiallyPaid': {
    color: 'orange',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  '& .super-app-theme--Unpaid': {
    color: '#000',
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
  },
  '& .super-app-theme--Cancelled': {
    color: 'red',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
}));

const MixSellInvoice = ({
  loadedCustomers,
  defaultfromdate,
  defaulttodate,
  defaultStatus,
  fromOtherComponent,
}) => {

  const local_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.MIX_REPORT_INVOICE);

  const [status, setStatus] = useState([lStatusOption[0]]);
  const [fromDate, setFromDate] = useState(new Date(new Date().setDate(new Date().getDate() - 1)));
  const [toDate, setToDate] = useState(new Date());
  const [listData, setListData] = useState([]);
  const [salesListLoader, setSalesListLoader] = useState(false);
  const [fetchData, setFetchData] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [pdfName, setPdfName] = useState("");
  const [pdfByte, setPdfByte] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [showBucketDetailModal, setShowBucketDetailModal] = useState(false);
  const [bucketId, setBucketId] = useState([]);
  const [totalInvoice, setTotalInvoice] = useState("");
  const [totalAmount, setTotalAmount] = useState(0.0);
  const [pendingAmount, setPendingAmount] = useState(0.0);
  const [paidAmount, setPaidAmount] = useState(0.0);
  const [filterValues, setFilterValues] = useState({});
  const [groupBy, setGroupBy] = useState(true);
  const [customerData, setCustomerData] = useState({
    customer: [],
    customerOptions: [],
  });
  const [totalUSD, setTotalUSD] = useState(0);
  const [totalINR, setTotalINR] = useState(0);

  const [showUserDetailModal, setShowUserDetailModal] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    PageTitle("MIX_REPORT_INVOICE");
    if (fromOtherComponent) {
      setFromDate(defaultfromdate);
      setToDate(defaulttodate);
      setStatus(defaultStatus);
    }

    if (loadedCustomers) {
      setCustomerData(loadedCustomers);
      setFetchData(true);
    } else if (Constants.loggedInUser.usertype !== "C") {
      getAllCustomerData();
    } else {
      setFetchData(true);
      customerData.customer.push({ label: Constants.loggedInUser.companyname, value: Constants.loggedInUser.id })
    }
  }, []);

  const getAllCustomerData = () => {
    MixSaleProxy.GetCustomersCreatedInvoice(
      Utility.isReadAllowed(local_Permission) ? Constants.loggedInUser.locationid : -1,
      Utility.isReadAllowed(local_Permission) ? -1 : Constants.loggedInUser.id,
      Constants.loggedInUser.usertype, (response) => {
        if (response) {
          prepareUserData(response);
        }
      });
  }

  const prepareUserData = (response) => {

    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.companyname,
      };
      optionsArray.push(option);
      return true;
    });

    setCustomerData({
      customerOptions: optionsArray,
      customer: optionsArray.length > 0 ? [optionsArray[0]] : []
    });
    setFetchData(true);

    return true;
  };

  const fullOptionToValue = (selectedData, mainData) => {
    let newArr = [];
    selectedData.map((data) => {
      if (data.value === "*") {
        return (mainData.map((option) => {
          if (option.value !== "*") {
            newArr.push(option.value);
            return true;
          }
          return true;
        }));
      }
      return true;
    })
    return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
  };

  const handleBucketDetailModal = (params) => {
    setBucketId(params.value);
    setShowBucketDetailModal(true)
  };

  useEffect(() => {
    if (fetchData) {
      if (customerData.customer) {
        handleSearch(fromDate, toDate, customerData.customer);
      }
    }
  }, [fetchData, fromDate, toDate, customerData.customer]);

  const handleSearch = (fromDate, toDate, customer) => {
    setSalesListLoader(true);
    let tempStatus = status.find(i => i.value === -1) ?
      lStatusOption.filter(i => i.value !== -1).map(i => i.value) :
      status.map(i => i.value);
    let data = {
      from: (fromDate !== null) ? dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z" : null,
      to: (toDate !== null) ? dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z" : null,
      users: fullOptionToValue(customer, customerData.customerOptions),
      status: tempStatus,
      locationid: fromOtherComponent ? -1 : (Utility.isReadAllowed(local_Permission) ? Constants.loggedInUser.locationid : - 1),
    };
    MixSaleProxy.GetAllMixInvoiceReport(Constants.loggedInUser.id, Constants.loggedInUser.usertype, data, (response) => {
      if (response) {
        const uniqueFilterValues = {
          status: Utility.getDistinctOptions(response, "status"),
          exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
          user: Utility.getDistinctOptions(response, "userid"),
          broker: Utility.getDistinctOptions(response, "brokerid"),
          customer: Utility.getDistinctOptions(response, "customerid"),
          invoicecustomer: Utility.getDistinctOptions(response, "invoicecustomerid"),
          tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
        };

        const bucketNames = [];
        response.forEach(item => {
          if (item.buckets && item.buckets.length > 0) {
            item.buckets.forEach(bucket => {
              const bucketName =
                `${bucket.stonetypefullname} | ${bucket.shape} | ${bucket.size} | ${bucket.color} | ${bucket.clarity}`;
              if (!bucketNames.includes(bucketName)) {
                bucketNames.push(bucketName);
              }
            });
          }
        });

        const combinedFilterValues = {
          status: uniqueFilterValues.status,
          exchangecurrency: uniqueFilterValues.exchangecurrency,
          user: uniqueFilterValues.user.map(value => {
            const matchingItem = response.find(item => item.userid === value);
            return matchingItem ? `${value} | ${matchingItem.username}` : [];
          }),
          broker: uniqueFilterValues.broker.map(value => {
            const matchingItem = response.find(item => item.brokerid === value);
            if (matchingItem) {
              let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokername}`;
              return displayValue;
            }
            return [];
          }),
          customer: uniqueFilterValues.customer.map(value => {
            const matchingItem = response.find(item => item.customerid === value);
            return matchingItem ? `${value} | ${matchingItem.customername}` : [];
          }),
          tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
            const matchingItem = response.find(item => item.tradingcompanyid === value);
            return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
          }),
          bucketname: bucketNames,
          stonetype: Utility.getDistinctOptions(response, "stonetype"),
        };

        loadSummaryData(response);
        setFilterValues(combinedFilterValues);
        setListData(response);
        handleArray(response);
        setSalesListLoader(false);
        setFetchData(false);
      } else {
        setSalesListLoader(false);
        setErrorSnackbar(true);
      }
    });
  };

  const loadSummaryData = (listData) => {
    if (!Array.isArray(listData)) return;
    let totalInvoice = listData.length;
    let tAmount = 0;
    let pendingAmount = 0
    let paidAmount = 0;
    listData.forEach((item) => {
      tAmount += item.finalpayableamount;
      pendingAmount += item.finalpayableamount - item.amountpaid;
      paidAmount += item.amountpaid
    });
    setTotalInvoice(totalInvoice);
    setTotalAmount(tAmount);
    setPendingAmount(pendingAmount);
    setPaidAmount(paidAmount);
  }

  const handleArray = (lListData) => {
    let newMainData = [], totalUSD = 0, totalINR = 0;
    const stonetypefullname = new Set();
    if (lListData.length > 0) {
      lListData.forEach((list) => {
        stonetypefullname.add(...Utility.getDistinctOptions(list.buckets, "stonetypefullname"));
        list.buckets.forEach((stone) => {
          stone.exchangecurrency = list.exchangecurrency
          stone.exchangerate = list.exchangerate
          newMainData.push(stone);

          totalUSD += stone.final_amount;
          totalINR += stone.final_amountinr;
        });
      });
    }

    setFilterValues(val => ({ ...val, stonetypefullname: [...stonetypefullname] }));
    setMainData(newMainData);
    setTotalUSD(totalUSD.toFixed(2));
    setTotalINR(totalINR.toFixed(2));
  };

  const downloadPDF = (invoiceid, fileBytes) => {
    setPdfByte(fileBytes);
    setPdfName(`Invoice` + invoiceid + `.pdf`);
    openModal()
  }

  const columnName = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "invoiceid",
      headerName: "INVOICE ID",
      headerAlign: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
    },
    {
      field: "bucketid",
      headerName: "BUCKETID",
      headerAlign: "center",
      align: "center",
      width: 80,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => handleBucketDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "bucketname",
      headerName: "BUCKET NAME",
      headerAlign: "center",
      align: "center",
      width: 300,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.bucketname : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) =>
        params.row.stonetypefullname +
        " | " +
        params.row.shape +
        " | " +
        params.row.size +
        " | " +
        params.row.color +
        " | " +
        params.row.clarity,
      renderCell: (params) =>
        params.row.stonetypefullname +
        " | " +
        params.row.shape +
        " | " +
        params.row.size +
        " | " +
        params.row.color +
        " | " +
        params.row.clarity,
    },
    {
      field: "stonetypefullname",
      headerName: "STONETYPE",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      width: 90,
      valueOptions: filterValues ? filterValues.stonetypefullname : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      field: "qty",
      headerName: "QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "piece",
      headerName: "PIECES",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
    },
    {
      field: "exchangecurrency",
      headerName: "EX. CURRENCY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 115,
    },
    {
      field: "exchangerate",
      headerName: "EX. RATE",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
    },
    {
      field: "sellqty",
      headerName: "SELL QTY",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 80,
    },
    {
      field: "price",
      headerName: "PPC $",
      headerAlign: "center",
      type: "number",
      align: "center",
      width: 80,
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
    },
    {
      field: "priceinr",
      headerName: "PPC ₹",
      headerAlign: "center",
      type: "number",
      align: "center",
      width: 80,
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.priceinr)
    },
    {
      field: "discount1",
      headerName: "DIS 1",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "discount2",
      headerName: "DIS 2",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 55,
    },
    {
      field: "discount3",
      headerName: "DIS 3",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 55,
    },
    {
      field: "final_amount",
      headerName: "FINAL AMOUNT $",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.final_amount)
    },
    {
      field: "final_amountinr",
      headerName: "FINAL AMOUNT ₹",
      headerAlign: "center",
      align: "center",
      width: 120,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.final_amountinr)
    },
    {
      field: "remarks",
      headerName: "REMARKS",
      headerAlign: "center",
      align: "center",
      width: 90,
    },
  ];

  const materialDefaultColumns = [
    {
      headerName: "INVOICE ID",
      field: "id",
      headerAlign: "center",
      width: 115,
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "STONETYPE",
      field: "stonetype",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => Constants.STONE_TYPE[params.value],
      renderCell: (params) => Constants.STONE_TYPE[params.value],
      width: 115,
    },
    {
      headerName: "USER",
      field: "userid",
      width: 185,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.user : [],
      filterOperators: Utility.combinedFilters(),
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => {
        return `${params.row.userid} | ${params.row.username}`;
      },
      renderCell: (params) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '5px', marginLeft: '10px' }}>
            {`${params.row.userid} | ${params.row.username}`}
          </span>
        </div>
      ),
    },
    {
      headerName: "BROKER COMPANY",
      field: "brokerid",
      width: 185,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.broker : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`;
      },
      renderCell: (params) => {
        let displayValue = params.row.brokerid === -1 ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {(params.row.brokerid === -1 || params.row.brokerid === null) ? " - " : displayValue}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "CUSTOMER COMPANY",
      field: "customerid",
      width: 225,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.customer : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.customerid} | ${params.row.customercompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.customerid} | ${params.row.customercompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "TRADING COMPANY",
      field: "tradingcompanyid",
      width: 200,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.tradingcompany : [],
      filterOperators: Utility.combinedFilters(),
      valueGetter: (params) => {
        return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
      },
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px', marginLeft: '10px' }}>
              {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
            </span>
          </div>
        );
      },
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXCHANGE CURRENCY",
      field: "exchangecurrency",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      width: 170,
      valueOptions: filterValues ? filterValues.exchangecurrency : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand
    },
    {
      headerName: "EXCHANGE RATE",
      field: "exchangerate",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "DAYS",
      field: "days",
      headerAlign: "center",
      width: 55,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPING COST",
      field: "shippingcost",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 110,
      renderCell: renderCellExpand
    },
    {
      headerName: "PDF",
      field: "invoicepdf",
      renderCell: (params) => (
        <BsFilePdf size={25} color="red" onClick={() => downloadPDF(params.row.id, params.row.invoicepdf)} />
      ),
      export: false,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "FINAL PAYABLE AMOUNT",
      field: "finalpayableamount",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 170,
      renderCell: renderCellExpand
    },
    {
      headerName: "PAID AMOUNT",
      field: "amountpaid",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 110,
      renderCell: renderCellExpand
    },
    {
      headerName: "DATE",
      field: "date",
      type: "date",
      width: 85,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "EXPORT",
      field: "export",
      renderCell: (params) =>
        params.row.export ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      align: "center",
      width: 65
    },
    {
      headerName: "COUNTRY OF FINAL DESTINATION",
      field: "countryoffinaldestination",
      headerAlign: "center",
      align: "center",
      width: 220,
      renderCell: renderCellExpand
    },
    {
      headerName: "COUNTRY OF ORIGIN",
      field: "countryoforigin",
      headerAlign: "center",
      width: 145,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "FINAL DESTINATION",
      field: "finaldestination",
      headerAlign: "center",
      align: "center",
      width: 135,
      renderCell: renderCellExpand
    },
    {
      headerName: "ENSURED BY",
      field: "ensuredby",
      headerAlign: "center",
      align: "center",
      width: 95,
      renderCell: renderCellExpand
    },
    {
      headerName: "BANK THROUGH",
      field: "bankthrough",
      renderCell: (params) =>
        params.row.bankthrough ? (
          <CheckIcon color="success" />
        ) : (
          <ClearIcon color="error" />
        ),
      headerAlign: "center",
      width: 115,
      align: "center",
    },
    {
      headerName: "PORT OF LOADING",
      field: "portofloading",
      headerAlign: "center",
      align: "center",
      width: 130,
      renderCell: renderCellExpand
    },
    {
      headerName: "SHIPPED BY",
      field: "shippedby",
      headerAlign: "center",
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "PORT OF DISCHARGE",
      field: "portofdischarge",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: renderCellExpand
    },
    {
      headerName: "REMARKS",
      field: "remarks",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand
    },
    {
      headerName: "TERMS",
      field: "terms",
      headerAlign: "center",
      type: "number",
      width: 60,
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand
    },
    {
      headerName: "DUE DATE",
      field: "duedate",
      type: "date",
      width: 85,
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
      headerAlign: "center",
      align: "center",
    },
  ];

  const columns = columnName;

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, mainData) => <DetailPanelContent row={row} mainData={mainData} />,
    [columns],
  );

  function DetailPanelContent({ row: rowProp, mainData }) {
    let row = mainData.filter(data => data.invoiceid === rowProp.id);

    return (
      <Stack
        sx={{ p: 1, height: '100%', boxSizing: 'border-box', borderBottom: "1px solid lightgrey" }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "83.5vw",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto'
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={row}
            getRowId={(row) => row.id}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },

              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              maxHeight: '35vh'
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  // Hide columns id, the other columns will remain visible
                  perfomaid: false,
                  id: false,
                },
              },
            }}
            hideFooter
          />
        </Box>
      </Stack>
    );
  }

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
            minWidth: 0,
            px: 1,
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            useFlexGap
            flexWrap="wrap"
            sx={{
              width: "100%",
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: { xs: "flex-start", sm: "flex-start" },
            }}
          >
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Total Invoice: <b>{totalInvoice ? totalInvoice : 0}</b>
            </Typography>

            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Total Amount: <b>{totalAmount ? totalAmount.toFixed(2) : 0}</b>
            </Typography>
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Pending Amount: <b>{pendingAmount ? pendingAmount.toFixed(2) : 0}</b>
            </Typography>
            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
              Paid Amount: <b>{paidAmount ? paidAmount.toFixed(2) : 0}</b>
            </Typography>
          </Stack>
        </Box>

        {salesListLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => {
                if (fromOtherComponent) {
                  handleSearch(fromDate, toDate, customerData.customer);
                } else {
                  getAllCustomerData();
                }
              }}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer", mt: 1 }}
            />
          </Tooltip>
        )}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    );
  }

  return (
    <div>
      {
        <Box px={1}>
          <CommonSnackbar
            show={errorSnackbar}
            message={Constants.APiFailErrorMessage}
            variant={"error"}
            autoHide={Constants.SnackBarCloseTimer}
            title={"Failed"}
            handleClose={() => setErrorSnackbar(false)}
          />
          {showBucketDetailModal ? (
            <BucketDetailModal
              show={showBucketDetailModal}
              bucketId={bucketId}
              handleClose={() => setShowBucketDetailModal(false)}
            />
          ) : null}

          {showUserDetailModal ? (
            <UserDetailModal
              show={true}
              handleClose={() => setShowUserDetailModal(false)}
              handleSelect={(selectedOption) => {
                const selectedCustomers = customerData.customerOptions.filter(opt =>
                  selectedOption.includes(opt.value)
                );
                setCustomerData({
                  ...customerData,
                  customer: selectedCustomers,
                })
                setShowUserDetailModal(false)
              }}
              userids={customerData.customerOptions.filter(option => option.value !== "*").map(cust => cust.value)}
              selectedIds={customerData.customer.length !== 0 ? customerData.customer.map(iCust => iCust.value) : []}
              usertype={"C"}
              loading={showUserDetailModal}
              isMulti={true}
            />
          ) : null}


          {/*need to send pdf in byte string to modal */}
          <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: "1 1 390px",
                minWidth: "300px",
                maxWidth: "450px",
                mt: 1,
              }}
            >
              <Typography sx={{ width: "150px", minWidth: "120px", mr: 1 }}>
                Customer Company
              </Typography>
              <Box sx={{ flex: 1 }}>
                <Select
                  menuPlacement="auto"
                  blurInputOnSelect={false}
                  menuPortalTarget={document.body}
                  styles={Constants.Styles}
                  closeMenuOnSelect={false}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  isMulti
                  options={customerData.customerOptions}
                  value={customerData.customer}
                  onChange={(selectedOption) => {
                    setCustomerData({
                      ...customerData,
                      customer: selectedOption,
                    });
                  }}
                />
              </Box>
              <Tooltip title="View More Data">
                <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                  <OpenInNewIcon
                    fontSize="medium"
                    color="action"
                    onClick={() => setShowUserDetailModal(true)}
                  />
                </span>
              </Tooltip>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minWidth: "250px",
                maxWidth: "350px",
                flex: "1 1 250px",
                mt: 1,
              }}
            >
              <Typography sx={{ mr: 2 }}>Status</Typography>
              <Box sx={{ flex: 1 }}>
                <Select
                  menuPlacement="auto"
                  blurInputOnSelect={false}
                  className="basic-single"
                  classNamePrefix="select"
                  value={status}
                  isSearchable={true}
                  name="status"
                  isMulti
                  menuPortalTarget={document.body}
                  styles={Constants.Styles}
                  options={lStatusOption}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                />
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minWidth: "200px",
                maxWidth: "250px",
                flex: "1 1 200px",
                mt: 1,
              }}
            >
              <Typography sx={{ mr: 2 }}>From</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="picker"
                  ampm
                  renderInput={(props) => (
                    <TextField
                      {...props}
                      size="small"
                      inputProps={{ ...props.inputProps, readOnly: true }}
                      fullWidth
                    />
                  )}
                  value={fromDate}
                  inputFormat="DD/MM/YYYY"
                  onChange={(newValue) => {
                    const now = dayjs();
                    const fromDate = dayjs(newValue)
                      .hour(now.hour())
                      .minute(now.minute())
                      .second(now.second())
                      .millisecond(now.millisecond())
                      .toDate();
                    setFromDate(fromDate);
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                minWidth: "200px",
                maxWidth: "250px",
                flex: "1 1 200px",
                mt: 1,
              }}
            >
              <Typography sx={{ mr: 2 }}>To</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="picker"
                  ampm
                  renderInput={(props) => (
                    <TextField
                      {...props}
                      size="small"
                      inputProps={{ ...props.inputProps, readOnly: true }}
                      fullWidth
                    />
                  )}
                  error={false}
                  value={toDate}
                  inputFormat="DD/MM/YYYY"
                  onChange={(newValue) => {
                    const now = dayjs();
                    const toDate = dayjs(newValue)
                      .hour(now.hour())
                      .minute(now.minute())
                      .second(now.second())
                      .millisecond(now.millisecond())
                      .toDate();
                    setToDate(toDate);
                  }}
                />
              </LocalizationProvider>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                mt: 1
              }}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <Switch
                        checked={groupBy}
                        onChange={() => setGroupBy(!groupBy)}
                      />
                      <Typography>By Invoice</Typography>
                    </Box>
                  }
                  label=""
                />
              </FormGroup>

              <LoadingButton
                loading={salesListLoader}
                loadingPosition="start"
                disabled={customerData.customerOptions.length === 0}
                variant="contained"
                onClick={() => handleSearch(fromDate, toDate, customerData.customer)}
                startIcon={<SearchOutlinedIcon size="large" />}
              >
                Search
              </LoadingButton>
            </Box>


          </Box>

          {!groupBy ? (
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "94vw",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                  color: "#1976d2",
                  padding: "4px 5px",
                  borderRadius: "4px",
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                height: '77vh'
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={false}
                density="compact"
                columns={columns}
                rows={mainData}
                getRowId={(row) => row.id}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "8px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "15px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "22px",
                  },

                  fontSize: Constants.defaultTableFontSize, fontWeight: 'bold'
                }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                      id: false,
                      qty: false,
                      piece: false
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
              />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: "black",
                  fontWeight: 'normal',
                  fontSize: Constants.defaultTableFontSize,
                  position: "absolute",
                  top: "0.7rem",
                  right: "25rem",
                  width: "59rem"
                }}
              >
                <p margin={0}>
                  <span>Total USD: </span> <b>{totalUSD}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Total INR: </span> <b>{totalINR}</b>
                </p>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
                height: !fromOtherComponent ? "75vh" : "66vh",
              }}
            >
              <StyledDataGrid
                rowHeight={65}
                disableRowSelectionOnClick={false}
                density="compact"
                columns={materialDefaultColumns}
                rows={listData}
                loading={salesListLoader}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "4px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "12px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "18px",
                  },

                  '& .MuiDataGrid-row': {
                    whiteSpace: 'nowrap',
                  },
                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                }}
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                getRowId={(row) => row.id}
                initialState={{
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                sortModel={[
                  {
                    field: 'id',
                    sort: 'desc',
                  },
                ]}
                getRowClassName={(params) => {
                  if (params.row.status === 'PAID') {
                    return 'super-app-theme--Paid';
                  } else if (params.row.status === 'CANCELLED') {
                    return 'super-app-theme--Cancelled';
                  } else if (params.row.amountpaid > 0) {
                    return 'super-app-theme--PartiallyPaid';
                  } else {
                    return 'super-app-theme--Unpaid';
                  }
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData)}
              />

              {/* <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: "black",
                  fontWeight: 'normal',
                  fontSize: Constants.defaultTableFontSize,
                  position: "absolute",
                  top: "0.7rem",
                  right: "25rem",
                  width: "59rem"
                }}
              >
                <p margin={0}>
                  <span>Total Invoice: </span> <b>{totalInvoice ? totalInvoice : 0}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Total Amount: </span> <b>{totalAmount ? totalAmount.toFixed(2) : 0}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Pending Amount: </span> <b>{pendingAmount ? pendingAmount.toFixed(2) : 0}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <span>Paid Amount: </span> <b>{paidAmount ? paidAmount.toFixed(2) : 0}</b>  &nbsp;&nbsp;
                </p>
              </Box>
              <Box
                style={{
                  position: "absolute",
                  top: 2,
                  right: "270px",
                  display: "flex",
                  flexWrap: "nowrap",
                }}
              >
                {salesListLoader ? (
                  <CircularProgress size="1rem" />
                ) : (
                  <Tooltip title="Reload List">
                    <RefreshOutlinedIcon
                      onClick={() => {
                        if (fromOtherComponent) {
                          handleSearch(fromDate, toDate, customerData.customer);
                        } else {
                          getAllCustomerData();
                        }
                      }}
                      color="primary"
                      fontSize="medium"
                      sx={{ cursor: "pointer", mt: 1 }}
                    />
                  </Tooltip>
                )}
              </Box> */}
            </Box>
          )}

        </Box>
      }
    </div>
  );
};

export default MixSellInvoice;
